/* src/app/private/components/leads/lead-meeting/lead-meeting.component.scss */
.p-select.p-disabled {
  background-color: transparent !important;
  cursor: not-allowed !important;
}
/*# sourceMappingURL=lead-meeting.component.css.map */
